import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case types.FETCH_SYSTEM_ALARM_PENDING:
      return {
        ...state,
        pending: true,
        data: [],
      };
    case types.FETCH_SYSTEM_ALARM_SUCCESS:
      return {
        ...state,
        pending: false,
        data: actions.payload,
      };
    case types.FETCH_SYSTEM_ALARM_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
        data: [],
      };
    default:
      return state;
  }
}
